module.exports = __webpack_public_path__ + "img/icon_kefu@3x.3d700dd9.png";